import portoImg1 from "../images/WebTravelerEsplor.png";
import portoImg2 from "../images/DanRent.png";
import portoImg3 from "../images/Monieapp.png";
import portoImg4 from "../images/agency.png";
import portoImg5 from "../images/news.png";
import portoImg6 from "../images/job.png";
import portoImg7 from "../images/donasiplus2.png";
import portoImg8 from "../images/hyper.png";
import portoImg9 from "../images/fuud.png";
import portoImg11 from "../images/ageone.png";
import portoImg10 from "../images/hero-image.png";
import portoImg12 from "../images/all.png";
import portoImg13 from "../images/graphic.png";

const portfolios = [
  {
    id: "01",
    imgUrl: portoImg8,
    category: "Ui",
    title: "Hyper Finance Management",
    description:
      "Hyper is the ideal solution to better organize and manage your finances. With easy access via the website, you can manage your personal or business finances easily, anywhere and anytime. Get real-time monitoring of your income and expenses, as well as the ability to track transactions quickly and efficiently. Available financial planning features help you budget, plan investments and set clear financial goals. By using this financial management website, you can gain full control over your finances and make wise decisions to achieve your desired financial goals.",
    technologies: ["Figma"],
    siteUrl:
      "https://www.behance.net/gallery/175283485/Finance-Management-Hyper",
  },

  {
    id: "02",
    imgUrl: portoImg7,
    category: "Ui",
    title: "Donasi Plus - Charity App",
    description:
      "The DonasiPlus is an innovative platform that aims to make it easier for users to make donations and have a positive impact on society and the environment",
    technologies: ["Figma"],
    siteUrl: "https://www.behance.net/gallery/172805545/Charity-App",
  },
  {
    id: "03",
    imgUrl: portoImg9,
    category: "Ui",
    title: "Food Delivery App",
    description:
      "Fuud is an application that aims to help users choose and order food easily. The app will display menus and prices from nearby restaurants, and users will be able to order food directly throught the app.",
    technologies: ["Figma"],
    siteUrl: "https://www.behance.net/gallery/170531163/Food-Delivery-App",
  },

  {
    id: "04",
    imgUrl: portoImg4,
    category: "Ui",
    title: "Digital Agency Website",
    description:
      "bloom is a platform that provides information and services about digital agencies. Here, you can find various services, such as UI/UX design, website creation, digital marketing, and many more. bloom also presents portfolios and testimonials from our clients as proof of the quality of the services we provide",
    technologies: ["Figma"],
    siteUrl:
      "https://www.behance.net/gallery/180412597/Digital-Agency-Web-Desgin",
  },

  {
    id: "05",
    imgUrl: portoImg5,
    category: "Ui",
    title: "News Website",
    description:
      "A news website is an online platform specifically designed to provide up-to-date news and information to internet users. News websites can have a variety of different characteristics and news coverage",
    technologies: ["Figma"],
    siteUrl: "https://www.behance.net/gallery/180412847/News-Website",
  },

  {
    id: "06",
    imgUrl: portoImg6,
    category: "Ui",
    title: "Job Portal Website",
    description:
      "Job portal websites, also known as online job boards or job search platforms, are digital platforms designed to connect job seekers with potential employers and facilitate the recruitment process. These websites play a pivotal role in the modern job market by providing a centralized and convenient platform for job seekers and employers to find each other.",
    technologies: ["Figma"],
    siteUrl: "https://www.behance.net/gallery/180413199/Job-Portal-Website",
  },
  {
    id: "07",
    imgUrl: portoImg1,
    category: "Front End",
    title: "Destination Website",
    description:
      "The main goal of this website is to provide various benefits to customers such as hotel bookings, airplane tickets, car rentals, tour packages. With these products, your traveler website provides a complete solution for customers who want to easily and efficiently plan their trips on one platform.",
    technologies: ["Figma"],
    siteUrl: "https://dribbble.com/wild4n",
  },

  {
    id: "08",
    imgUrl: portoImg2,
    category: "Ui",
    title: "Rental Car Website",
    description:
      "The car rental website product is a car rental service that allows customers to rent vehicles easily and quickly. Customers can choose from a variety of vehicle types and specify rental dates and durations.",
    technologies: ["Figma"],
    siteUrl: "https://dribbble.com/wild4n",
  },

  {
    id: "11",
    imgUrl: portoImg11,
    category: "Front End",
    title: "Age One Landing Page",
    description:
      "Age one a creative digital agency website, We are passionate about helping businesses grow and succeed in the digital age. We take pride in our work and strive to exceed your expectations every time.",
    technologies: ["Figma"],
    siteUrl: "https://ageone-3cc85f.webflow.io/",
  },

  {
    id: "10",
    imgUrl: portoImg10,
    category: "Front End",
    title: "Dankit",
    description: "Sebuah Website Selling Ui Kit",
    technologies: ["Figma", "Vue Js", "Tailwind CSS", "Rest API"],
    siteUrl: "https://dankit.netlify.app/",
  },

  {
    id: "12",
    imgUrl: portoImg12,
    category: "Front End",
    title: "All Project",
    description: "Semua Project Front-End & Back-End",
    technologies: ["All Project Front-End & Back-End"],
    siteUrl: "https://github.com/wildan78933",
  },
  {
    id: "09",
    imgUrl: portoImg3,
    category: "Ui",
    title: "Monie Mobile App",
    description:
      "Monie provides a digital wallet as a means of paying bills and daily needs using a barcode scan or pay directly through the application. users can top up via ATM first to top up the balance on the application",
    technologies: ["Figma"],
    siteUrl: "https://pitch.com/public/954659e2-22c7-458c-a4aa-9b5ad288100b",
  },

  {
    id: "13",
    imgUrl: portoImg13,
    category: "Graphic",
    title: "Portfolio Graphic Designer",
    description: "All Design",
    technologies: ["Adobe Photoshop", "Adobe Illustrator", "Corel Draw"],
    siteUrl:
      "https://drive.google.com/drive/folders/1QMX-J0mKWMDvY2dSnfMaYL5BCkFbiEm9?usp=drive_link",
  },
];

export default portfolios;
